// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('../raConstants/actionTypes');

// @ actions
const BrokerMyInvestmentsActions = require('actions/brokerMyInvestments');

const setPortfolioData = portfolioData => ({
    type: actionTypes.RA_OBJECTIVE_DETAILS_SET_PORTFOLIO_DATA,
    payload: { data: portfolioData },
});

const objectiveNameUpdateSuccess = (data, namePosition) => ({
    type: actionTypes.RA_OBJECTIVE_NAME_UPDATE_SUCCESS,
    payload: {
        data,
        namePosition,
    },
});

const objectiveNameUpdateFailure = error => ({
    type: actionTypes.RA_OBJECTIVE_NAME_UPDATE_FAILURE,
    payload: { error },
});

const setFromPGNotification = () => ({
    type: actionTypes.RA_OBJECTIVE_DETAILS_SET_FROM_PG_NOTIFICATION,
});

const setHeaderTitleError = () => ({
    type: actionTypes.RA_OBJECTIVE_DETAILS_HEADER_TITLE_ERROR_ENABLED,
});

const showEditAmountModal = currentGoalAmount => ({
    type: actionTypes.RA_OBJECTIVE_EDIT_AMOUNT_MODAL_SHOW,
    payload: { currentGoalAmount },
});

const hideEditAmountModal = () => ({
    type: actionTypes.RA_OBJECTIVE_EDIT_AMOUNT_MODAL_HIDE,
});

const objectiveNameUpdateInProgress = () => ({
    type: actionTypes.RA_OBJECTIVE_NAME_UPDATE_REQUEST,
});

const updateObjectiveName = (portfolioId, name, amount, namePosition) => (
    dispatch,
    getState,
) => {
    const clientName = getState()
        .profile.get('nombreCliente')
        .trim();
    const valueToUpdate = name
        ? { name: name }
        : { goalAmount: amount, clientName: clientName };
    const url = name ? 'raUpdateObjectiveName' : 'raUpdateObjective';
    const params = {
        portfolioId,
    };
    let requestData = {
        query: valueToUpdate,
    };
    dispatch(objectiveNameUpdateInProgress());
    return APIPost(dispatch, apiURLBuilder.getURL(url, params), requestData)
        .then(() => {
            dispatch(objectiveNameUpdateSuccess(valueToUpdate, namePosition));
            BrokerMyInvestmentsActions.outdateMyInvestments()(dispatch);
            BrokerMyInvestmentsActions.fetchMyInvestments()(dispatch, getState);
        })
        .catch(error => {
            if (error.error) {
                dispatch(objectiveNameUpdateFailure(error));
            } else {
                throw error;
            }
        });
};

const readPortfolioFromGlobalPosition = portfolioId => (dispatch, getState) => {
    const immGlobalPosition = getState().raGlobalPosition;
    if (immGlobalPosition.get('hasRoboHired')) {
        const immPortFolio = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
        ]);
        dispatch(setPortfolioData(immPortFolio.toJSON()));
    }
};

const reset = () => ({
    type: actionTypes.RA_OBJECTIVE_DETAILS_RESET,
});

const resetAmountValue = currentGoalAmount => ({
    type: actionTypes.RA_OBJECTIVE_RESET_AMOUNT_VALUE,
    payload: { currentGoalAmount },
});

module.exports = {
    hideEditAmountModal,
    setFromPGNotification,
    setHeaderTitleError,
    showEditAmountModal,
    updateObjectiveName,
    readPortfolioFromGlobalPosition,
    reset,
    resetAmountValue,
};
